/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,

  //dev
  // firebase: {
  //   // apiKey: "AIzaSyBRfWKiLZ8N8bqmjBxQtlefwo7viAi9KV8",
  //   // authDomain: "chatmyorder-dev.firebaseapp.com",
  //   // projectId: "chatmyorder-dev",
  //   // storageBucket: "chatmyorder-dev.appspot.com",
  //   // messagingSenderId: "663841293154",
  //   // appId: "1:663841293154:web:0e145b2de5c1615479623b",
  //   // measurementId: "G-S455GZ236K"
  //   apiKey: "AIzaSyCiWED_AtXSZ1AomTzTyQknOzQ17R5Lxls",
  //   authDomain: "cmo-riders-dev.firebaseapp.com",
  //   projectId: "cmo-riders-dev",
  //   storageBucket: "cmo-riders-dev.appspot.com",
  //   messagingSenderId: "583064026443",
  //   appId: "1:583064026443:web:98b8452adc570f3493fcce",
  //   measurementId: "G-Y39WTM1Z6B"
  // },
  // cloudFunctionsUrl: 'https://us-central1-chatmyorder-dev.cloudfunctions.net',

  // staging
  firebase: {
    apiKey: "AIzaSyCfa63BlRbRPI56UT5CjwT36HCcShGtbcY",
    authDomain: "cmo-riders-staging.firebaseapp.com",
    projectId: "cmo-riders-staging",
    storageBucket: "cmo-riders-staging.appspot.com",
    messagingSenderId: "577172260177",
    appId: "1:577172260177:web:035d1b91ea2c3b0572ff70",
    measurementId: "G-NFPX3NBD8Q"
  },
  cloudFunctionsUrl: 'https://us-central1-cmo-riders-staging.cloudfunctions.net',
  
  // //prod
  // firebase: {
  //   apiKey: "AIzaSyDQEoeKS1SZGIdeNeya5K9pkGrSQJ1u7Ss",
  //   authDomain: "cmo-riders-production.firebaseapp.com",
  //   projectId: "cmo-riders-production",
  //   storageBucket: "cmo-riders-production.appspot.com",
  //   messagingSenderId: "71519210255",
  //   appId: "1:71519210255:web:15e6fc197c865e6eeccc7a",
  //   measurementId: "G-LB6ZJ0XVDY"
  // },
  //cloudFunctionsUrl: 'https://us-central1-cmo-riders-production.cloudfunctions.net',

};
